module.exports = __webpack_public_path__ + "static/media/Simple UI@1x.8b7137da.png";